import { render, staticRenderFns } from "./updatepayment.vue?vue&type=template&id=2634dafb"
import script from "./updatepayment.vue?vue&type=script&lang=js"
export * from "./updatepayment.vue?vue&type=script&lang=js"
import style0 from "./updatepayment.vue?vue&type=style&index=0&id=2634dafb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports